import { facilityDetailUrl } from '../../../../../containers/common/constant/appUrl'
import { OperationId } from '../../../../../containers/common/constant/operationLog'
import { Link } from '../../link'
import { TitleLabel } from '../../titleLabel'

// 施設名
const FacilityLinkedName = (props: {facilityId: string, facilityName: string}) => (
  <Link to={facilityDetailUrl.url(props.facilityId)} operationLog={{ operationId: OperationId.OP_00000027 }}>
    <TitleLabel>{props.facilityName}</TitleLabel>
  </Link>
);
export default FacilityLinkedName;